import { Constants } from 'utils/Constants';
import { usePersistentStorage } from 'hooks/usePersistentStorage';
import { configureOpenApiClients } from '../../api/configure';
import {
  recurringPaymentAuthorizeRecurringPayment,
  recurringPaymentCreateRecurringPayment,
  recurringPaymentDeleteRecurringPayment,
  recurringPaymentGetRecurringPayments,
  recurringPaymentUpdateRecurringPayment,
} from '../../api/v1';

export const useRecurringPaymentApi = (token: string) => {
  const { getCachedItem } = usePersistentStorage();
  configureOpenApiClients();

  const getRecurringPayments = async () =>
    await recurringPaymentGetRecurringPayments({ headers: { authorization: 'Bearer ' + token } });

  const createRecurringPayment = async (isPrimary: boolean) =>
    await recurringPaymentCreateRecurringPayment({
      headers: { authorization: 'Bearer ' + token },
      query: {
        nickname: '',
        redirectUrl: `${window.location.protocol}//${window.location.host}${Constants.ROUTE_NETS_REDIRECT}`,
        isPrimary,
      },
    });

  const deleteRecurringPayment = async (id: number) =>
    await recurringPaymentDeleteRecurringPayment({
      path: { recurringPaymentId: id },
      headers: { authorization: 'Bearer ' + token },
    });

  const updateRecurringPayment = async (data: { id: number; nickname: string; isPrimary: boolean }) =>
    await recurringPaymentUpdateRecurringPayment({
      path: { recurringPaymentId: data.id },
      headers: { authorization: 'Bearer ' + token },
      query: { nickname: data.nickname, isPrimary: data.isPrimary },
    });

  const authorizeRecurringPayment = async () =>
    await recurringPaymentAuthorizeRecurringPayment({
      path: { recurringPaymentId: Number(getCachedItem(Constants.RECURRING)) },
      headers: { authorization: 'Bearer ' + token },
    });

  return {
    getRecurringPayments,
    createRecurringPayment,
    deleteRecurringPayment,
    updateRecurringPayment,
    authorizeRecurringPayment,
  };
};
